import "./index.scss";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import Logo from "../../components/icons/Logo";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import BeverageCart from "../../components/icons/NavIcons/BeverageCart";
import EventHall from "../../components/icons/NavIcons/EventHall";
import GolfClubAndLounge from "../../components/icons/NavIcons/GolfClubAndLounge";
import ProShop from "../../components/icons/NavIcons/ProShop";
import { Header } from "../../components/Header";

const GolfPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page golfPage">
            <Header />
            <div className="page-header">Golf Course</div>
            <div className="text-blocks">
                <div className="std-text">
                    Whether you're organizing tournaments,
                    scheduling and tracking tee times, managing the
                    pro shop, directing staff or overseeing player
                    experiences, start with the reliable foundation of
                    Agilysys Golf.
                </div>

            </div>
            <div className="tap">
                <img src={Tap} alt="" />
                <div className="tap-prompt">
                    Tap on each section of the map{'\n'}
                    To drill into the details
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Golf", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus/agilysys");
            }}>
                <Logo />
            </div>
            <div className="golf-map">
                <div className="cart">
                    <BeverageCart onClick={()=>{
                        _logEvent('click', "Golf", "Beverage Cart");
                        addFlow("Beverage Cart");
                        navigate("cart", { relative: "path" })
                    }}/>
                </div>
                <div className="hall">
                    <EventHall onClick={()=>{
                        _logEvent('click', "Golf", "Event Hall");
                        addFlow("Event Hall");
                        navigate("hall", { relative: "path" })
                    }}/>
                </div>
                <div className="club">
                    <GolfClubAndLounge onClick={()=>{
                        _logEvent('click', "Golf", "Club & Lounge");
                        addFlow("Club & Lounge");
                        navigate("lounge", { relative: "path" })
                    }}/>
                </div>
                <div className="shop">
                    <ProShop onClick={()=>{
                        _logEvent('click', "Golf", "Pro Shop");
                        addFlow("Pro Shop");
                        navigate("shop", { relative: "path" })
                    }}/>
                </div>
            </div>
            {/* 
            <div className="cart-link link" onClick={()=>{
                _logEvent('click', "Golf", "Beverage Cart");
                addFlow("Beverage Cart");
                navigate("cart", { relative: "path" })}}/>
            <div className="hall-link link" onClick={()=>{
                _logEvent('click', "Golf", "Event Hall");
                addFlow("Event Hall");
                navigate("hall", { relative: "path" })}}/>
            <div className="lounge-link link" onClick={()=>{
                _logEvent('click', "Golf", "Club & Lounge");
                addFlow("Club & Lounge");
                navigate("lounge", { relative: "path" })}}/>
            <div className="shop-link link" onClick={()=>{
                _logEvent('click', "Golf", "Pro Shop");
                addFlow("Pro Shop");
                navigate("shop", { relative: "path" })}}/>
                */}
        </div>
    )
}
export default GolfPage;